import React from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Add useNavigate
import { Container, Box, Typography, Button } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter'; 
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const MovieDetail = ({ movies }) => {
  const { id } = useParams();
  const movieId = parseInt(id);
  const navigate = useNavigate(); // Add useNavigate hook

  // Log the movie ID and movies array for debugging
  console.log('Movie ID from URL:', movieId);
  console.log('Movies array:', movies);

  // Find the movie by ID
  const movie = movies.find(movie => movie.id === movieId);

  if (!movie) {
    console.error('Movie not found');
    return <div>Movie not found</div>;
  }

  // Calculate funding progress percentage for the progress bar
  const fundingProgress = (movie.currentFunding / movie.targetFunding) * 100;

  // Current page URL for sharing
  const currentUrl = encodeURIComponent(window.location.href);
  const shareText = encodeURIComponent(`Check out this movie: ${movie.name} - ${window.location.href}`);

  // Handle Invest Now button click
  const handleInvestNow = () => {
    navigate(`/invest/${movieId}`); // Navigate to the InvestPage with the movie ID
  };

  return (
    <Container maxWidth="lg" style={{ backgroundColor: '#1a1a1a', color: '#fff', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="flex-start" marginBottom="20px">
        <img 
          src={movie.image} 
          alt={movie.name} 
          style={{ width: '300px', height: 'auto', marginRight: '20px', borderRadius: '10px' }} 
        />
        <Box textAlign="left">
          <Typography variant="h4" component="h1" gutterBottom>
            {movie.name}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {movie.description}
          </Typography>
          <Typography variant="h6" component="h3" gutterBottom>
            Cast
          </Typography>
          <Typography variant="body2" gutterBottom>
            {movie.cast.join(', ')}
          </Typography>
          <Typography variant="h6" component="h3" gutterBottom>
            Crew
          </Typography>
          <Typography variant="body2" gutterBottom>
            {movie.crew.join(', ')}
          </Typography>
          <Box marginTop="20px">
            <Typography variant="body2" gutterBottom>
              Current Funding: ₹{movie.currentFunding.toLocaleString()} / ₹{movie.targetFunding.toLocaleString()}
            </Typography>
            <Box width="100%" backgroundColor="#555" height="10px" borderRadius="5px">
              <Box 
                width={`${fundingProgress}%`} 
                backgroundColor="#4CAF50" 
                height="100%" 
                borderRadius="5px" 
              />
            </Box>
          </Box>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleInvestNow} // Add onClick handler
            style={{ marginTop: '20px', backgroundColor: '#9C27B0', color: '#fff', padding: '10px 20px', borderRadius: '5px' }}
          >
            Invest Now
          </Button>
          {/* Social Sharing Buttons */}
          <Box marginTop="10px" display="flex" gap="10px">
            <Button
              variant="outlined"
              href={`https://facebook.com/sharer.php?u=${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ padding: '5px', minWidth: 'auto', color: '#3b5998', borderColor: '#3b5998' }}
            >
              <FacebookIcon />
            </Button>
            <Button
              variant="outlined"
              href={`https://twitter.com/intent/tweet?url=${currentUrl}&text=${shareText}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ padding: '5px', minWidth: 'auto', color: '#1da1f2', borderColor: '#1da1f2' }}
            >
              <TwitterIcon />
            </Button>
            <Button
              variant="outlined"
              href={`https://wa.me/?text=${shareText}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ padding: '5px', minWidth: 'auto', color: '#25d366', borderColor: '#25d366' }}
            >
              <WhatsAppIcon />
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Comments Section */}
      <Box marginTop="20px">
        <Typography variant="h6" component="h3" gutterBottom>
          Comments
        </Typography>
        <Box marginBottom="10px">
          <textarea 
            placeholder="Add a comment..." 
            style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: '5px', border: 'none' }}
          />
          <Button 
            variant="contained" 
            color="primary" 
            style={{ backgroundColor: '#9C27B0', color: '#fff', padding: '10px 20px', borderRadius: '5px' }}
          >
            Post Comment
          </Button>
        </Box>
        <Typography variant="body2">
          No comments yet. Be the first to comment!
        </Typography>
      </Box>
    </Container>
  );
};

export default MovieDetail;